import type {
  CreateMeRequestBody,
  MeRequestDetail,
  MeRequestListItem,
  MeRequestMessageBody,
} from "@evolua/api-client";

const store: MeRequestDetail[] = [];

function toListItem(d: MeRequestDetail): MeRequestListItem {
  const { body: _b, attachmentObjectIds: _a, messages: _m, history: _h, ...rest } = d;
  return rest;
}

/** Demo solicitações genéricas (FASE-06-T39). */
export function listDemoMeRequests(): { data: MeRequestListItem[] } {
  return {
    data: [...store]
      .sort((a, b) => b.createdAt.localeCompare(a.createdAt))
      .map(toListItem),
  };
}

export function getDemoMeRequest(id: string): MeRequestDetail {
  const item = store.find((s) => s.id === id);
  if (!item) throw new Error("Solicitação não encontrada");
  return structuredClone(item);
}

export function createDemoMeRequest(body: CreateMeRequestBody): MeRequestDetail {
  const id = crypto.randomUUID();
  const at = new Date().toISOString();
  const detail: MeRequestDetail = {
    id,
    type:
      body.kind === "DECLARATION"
        ? "DECLARATION_REQUEST"
        : body.kind === "QUESTION"
          ? "QUESTION_REQUEST"
          : "CORRECTION_REQUEST",
    kind: body.kind,
    subject: body.subject,
    status: "IN_PROGRESS",
    createdAt: at,
    updatedAt: at,
    href: `/minhas-solicitacoes/${id}`,
    body: body.body,
    attachmentObjectIds: body.attachmentObjectIds ?? [],
    messages: [
      {
        id: crypto.randomUUID(),
        fromSubject: "demo-employee",
        fromRole: "EMPLOYEE",
        body: body.body,
        attachmentObjectIds: body.attachmentObjectIds ?? [],
        at,
      },
    ],
    history: [
      {
        id: crypto.randomUUID(),
        action: "STARTED",
        at,
        actorSubject: "demo-employee",
        comment: null,
      },
    ],
  };
  store.unshift(detail);
  return structuredClone(detail);
}

export function addDemoMeRequestMessage(
  id: string,
  body: MeRequestMessageBody,
): MeRequestDetail {
  const item = store.find((s) => s.id === id);
  if (!item) throw new Error("Solicitação não encontrada");
  if (item.status !== "IN_PROGRESS") throw new Error("Solicitação encerrada");
  const at = new Date().toISOString();
  item.messages.push({
    id: crypto.randomUUID(),
    fromSubject: "demo-employee",
    fromRole: "EMPLOYEE",
    body: body.body,
    attachmentObjectIds: body.attachmentObjectIds ?? [],
    at,
  });
  if (body.attachmentObjectIds?.length) {
    item.attachmentObjectIds = [
      ...item.attachmentObjectIds,
      ...body.attachmentObjectIds.filter((x) => !item.attachmentObjectIds.includes(x)),
    ];
  }
  item.updatedAt = at;
  return structuredClone(item);
}
